export default __webpack_public_path__ + "static/media/Saterllite.3605b9d1.png";